import {Routes} from "@angular/router";
import {MapViewComponent} from "./view/map-view/map-view.component";
import {AuthGuard} from "../../_auth/auth.guard";
import {PermissionService} from "../../_auth/permission.service";

export const GEOLOCATIONTRACKER_ROUTES: Routes = [
  {
    path: "dashboard", component: MapViewComponent,
    canActivate: [AuthGuard], data: {roles: PermissionService.owner.default}
  }
]
